module.exports = __webpack_public_path__ + "img/people.4bf1843.png";